// ================= LINKEDIN UNICODE MAPS =================

const BOLD_MAP = {
  a:'𝗮',b:'𝗯',c:'𝗰',d:'𝗱',e:'𝗲',f:'𝗳',g:'𝗴',h:'𝗵',i:'𝗶',j:'𝗷',k:'𝗸',l:'𝗹',
  m:'𝗺',n:'𝗻',o:'𝗼',p:'𝗽',q:'𝗾',r:'𝗿',s:'𝘀',t:'𝘁',u:'𝘂',v:'𝘃',w:'𝘄',x:'𝘅',
  y:'𝘆',z:'𝘇',A:'𝗔',B:'𝗕',C:'𝗖',D:'𝗗',E:'𝗘',F:'𝗙',G:'𝗚',H:'𝗛',I:'𝗜',J:'𝗝',
  K:'𝗞',L:'𝗟',M:'𝗠',N:'𝗡',O:'𝗢',P:'𝗣',Q:'𝗤',R:'𝗥',S:'𝗦',T:'𝗧',U:'𝗨',V:'𝗩',
  W:'𝗪',X:'𝗫',Y:'𝗬',Z:'𝗭',
  '0':'𝟬','1':'𝟭','2':'𝟮','3':'𝟯','4':'𝟰','5':'𝟱','6':'𝟲','7':'𝟳','8':'𝟴','9':'𝟵',
};

const ITALIC_MAP = {
  a:'𝘢',b:'𝘣',c:'𝘤',d:'𝘥',e:'𝘦',f:'𝘧',g:'𝘨',h:'𝘩',i:'𝘪',j:'𝘫',k:'𝘬',l:'𝘭',
  m:'𝘮',n:'𝘯',o:'𝘰',p:'𝘱',q:'𝘲',r:'𝘳',s:'𝘴',t:'𝘵',u:'𝘶',v:'𝘷',w:'𝘸',x:'𝘹',
  y:'𝘺',z:'𝘻',A:'𝘈',B:'𝘉',C:'𝘊',D:'𝘋',E:'𝘌',F:'𝘍',G:'𝘎',H:'𝘏',I:'𝘐',J:'𝘑',
  K:'𝘒',L:'𝘓',M:'𝘔',N:'𝘕',O:'𝘖',P:'𝘗',Q:'𝘘',R:'𝘙',S:'𝘚',T:'𝘛',U:'𝘜',V:'𝘝',
  W:'𝘞',X:'𝘟',Y:'𝘠',Z:'𝘡',
};

const BOLD_ITALIC_MAP = {
  a:'𝙖',b:'𝙗',c:'𝙘',d:'𝙙',e:'𝙚',f:'𝙛',g:'𝙜',h:'𝙝',i:'𝙞',j:'𝙟',k:'𝙠',l:'𝙡',
  m:'𝙢',n:'𝙣',o:'𝙤',p:'𝙥',q:'𝙦',r:'𝙧',s:'𝙨',t:'𝙩',u:'𝙪',v:'𝙫',w:'𝙬',x:'𝙭',
  y:'𝙮',z:'𝙯',A:'𝘼',B:'𝘽',C:'𝘾',D:'𝘿',E:'𝙀',F:'𝙁',G:'𝙂',H:'𝙃',I:'𝙄',J:'𝙅',
  K:'𝙆',L:'𝙇',M:'𝙈',N:'𝙉',O:'𝙊',P:'𝙋',Q:'𝙌',R:'𝙍',S:'𝙎',T:'𝙏',U:'𝙐',V:'𝙑',
  W:'𝙒',X:'𝙓',Y:'𝙔',Z:'𝙕',
};

// Convert a string using a character map
const applyMap = (text, map) =>
  text.split('').map((ch) => map[ch] || ch).join('');

// ================= CONVERT HTML TO LINKEDIN PLAIN TEXT =================
export const convertHtmlToLinkedIn = (html) => {
  // Create a temporary DOM element to parse the HTML
  const temp = document.createElement('div');
  temp.innerHTML = html;

  const processNode = (node, isBold = false, isItalic = false) => {
    // Text node — apply Unicode formatting
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      if (isBold && isItalic) return applyMap(text, BOLD_ITALIC_MAP);
      if (isBold) return applyMap(text, BOLD_MAP);
      if (isItalic) return applyMap(text, ITALIC_MAP);
      return text;
    }

    // Element node
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = node.tagName.toLowerCase();

      // Detect bold/italic from tag or style
      const style = node.getAttribute('style') || '';
      const nodeBold =
        isBold ||
        tag === 'b' ||
        tag === 'strong' ||
        style.includes('font-weight: bold') ||
        style.includes('font-weight:bold') ||
        style.includes('font-weight: 700') ||
        style.includes('font-weight:700');

      const nodeItalic =
        isItalic ||
        tag === 'i' ||
        tag === 'em' ||
        style.includes('font-style: italic') ||
        style.includes('font-style:italic');

      // Process children recursively
      let result = '';
      node.childNodes.forEach((child) => {
        result += processNode(child, nodeBold, nodeItalic);
      });

      // Add line breaks for block elements
      if (['p', 'div', 'br'].includes(tag)) {
        result += '\n';
      }

      return result;
    }

    return '';
  };

  let result = '';
  temp.childNodes.forEach((node) => {
    result += processNode(node);
  });

  // Clean up excessive newlines (max 2 consecutive)
  return result.replace(/\n{3,}/g, '\n\n').trim();
};